import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ServicesSection from './components/ServicesSection';
import CalculadorHome from './components/CalculadorHome';
import TestimonialsSection from './components/TestimonialsSection';
import ZonasSection from './components/ZonasSection';
import ServiciosAdicionales from './components/ServiciosAdicionales';
import CtaSection from './components/CtaSection';
import { updatePageSEO } from '../../utils/seoConfig';

const HomePage = () => {
  useEffect(() => {
    updatePageSEO('home');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ServicesSection />
        <CalculadorHome />
        <TestimonialsSection />
        <ZonasSection />
        <ServiciosAdicionales />
        <CtaSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default HomePage;
